<template>
  <b-card
    class="news-details-source"
    no-body
  >
    <b-card-header class="border-bottom">
      <b-card-title class="font-weight-bold text-secondary font-medium-3">
        <span>{{ sourcesData.title }}</span>
      </b-card-title>
    </b-card-header>
    <div class="mt-2 mb-2">
      <b-row class="mt-1 font-medium-1 font-weight-bold text-dark text-center">
        <b-col
          v-for="(item, index) in sourcesData.list"
          :key="`sources-item-${index}`"
          xl="6"
          md="6"
          sm="4"
          :class="item.customClass"
        >
          <b-col
            v-if="item.sourceValue"
            class="d-flex justify-content-around"
          >
            <b-media
              no-body
              class="mt-2 mx-5"
            >
              <b-media-aside>
                <b-avatar
                  size="48"
                  :variant="item.color"
                >
                  <feather-icon
                    size="36"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.sourceTitle }}
                </h4>
                <b-card-text class="font-medium-1 mb-0 text-center">
                  Views: {{ item.sourceValue }}<br>
                  ( {{ item.sourcePercentage }}% )
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import {
    BCard, BCardTitle, BCardText, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BCardHeader,
} from 'bootstrap-vue'

export default {
    components: {
        StatisticCardVertical,
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardText,
        BMedia,
        BAvatar,
        BMediaAside,
        BMediaBody,
        BCardHeader,
    },
    props: {
        sourcesData: {
            type: Object,
            default: () => {
            },
        },
    },

    data() {
        return {}
    },
}
</script>
